/** List of available MT4 server identifiers. */
export const mt4Servers = [
  'REAL01',
  'REAL02',
  'REAL03',
  'REAL04',
  'REAL05',
  'ML_REAL01',
  'ML_DEMO01',
  'DEMO',
  'TMM_REAL01',
  'SVG_REAL01',
] as const
